<ng-container *ngIf="hasData; else emptyState">
	<section class="section-header">
		<div class="header-content">
			<div class="header-left">
				<i class="fa-solid fa-scale-balanced"></i>
				<div class="header-text">
					<h1>Estados Financieros Anuales</h1>
					<p class="header-subtitle">Estado de Resultados + Balance General — datos del Excel parseado</p>
				</div>
			</div>
			<div class="header-right">
				<p-tag [value]="periods.length + (periods.length === 1 ? ' periodo' : ' periodos')" severity="info"></p-tag>
				<p-tag value="Importado" severity="success" icon="pi pi-check-circle"></p-tag>
			</div>
		</div>
	</section>

	<section class="info-card" *ngIf="incomeRows.length > 0">
		<div class="card-header">
			<i class="fa-solid fa-chart-line"></i>
			<h3>Estado de Resultados</h3>
		</div>
		<div class="card-content">
			<table class="data-table">
				<thead>
					<tr>
						<th class="concept">Concepto</th>
						<ng-container *ngFor="let p of periods; trackBy: trackByPeriod">
							<th class="num" colspan="2">{{ p.year }}</th>
						</ng-container>
						<th class="num" *ngFor="let v of variations">
							Δ% {{ v.fromPeriod | date:'yyyy' }} → {{ v.toPeriod | date:'yyyy' }}
						</th>
					</tr>
					<tr class="sub-headers">
						<th></th>
						<ng-container *ngFor="let p of periods">
							<th class="num">Monto</th>
							<th class="num">%</th>
						</ng-container>
						<th *ngFor="let v of variations"></th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let row of incomeRows; trackBy: trackByRowIndex"
						[class.category]="row.isCategory"
						[class.calculated]="row.isCalculated && !row.isCategory">
						<td class="concept" [style.padding-left.px]="12 + row.indent * 16">{{ row.label }}</td>
						<ng-container *ngFor="let p of periods">
							<td class="num">{{ getAmount(p, row.rowIndex) | currency:'MXN':'symbol-narrow':'1.0-0' }}</td>
							<td class="num pct">{{ getPercentage(p, row.rowIndex) | percent:'1.1-1' }}</td>
						</ng-container>
						<td class="num pct" *ngFor="let v of variations">
							{{ getVariation(v, row.rowIndex) | percent:'1.1-1' }}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</section>

	<section class="info-card" *ngIf="balanceRows.length > 0">
		<div class="card-header">
			<i class="fa-solid fa-vault"></i>
			<h3>Balance General</h3>
		</div>
		<div class="card-content">
			<table class="data-table">
				<thead>
					<tr>
						<th class="concept">Concepto</th>
						<ng-container *ngFor="let p of periods; trackBy: trackByPeriod">
							<th class="num" colspan="2">{{ p.year }}</th>
						</ng-container>
						<th class="num" *ngFor="let v of variations">
							Δ% {{ v.fromPeriod | date:'yyyy' }} → {{ v.toPeriod | date:'yyyy' }}
						</th>
					</tr>
					<tr class="sub-headers">
						<th></th>
						<ng-container *ngFor="let p of periods">
							<th class="num">Monto</th>
							<th class="num">%</th>
						</ng-container>
						<th *ngFor="let v of variations"></th>
					</tr>
				</thead>
				<tbody>
					<ng-container *ngFor="let row of balanceRows; trackBy: trackByRowIndex">
						<!-- Fila normal (monto + porcentaje + variación) -->
						<tr *ngIf="!row.isCheck"
							[class.category]="row.isCategory"
							[class.calculated]="row.isCalculated && !row.isCategory">
							<td class="concept" [style.padding-left.px]="12 + row.indent * 16">{{ row.label }}</td>
							<ng-container *ngFor="let p of periods">
								<td class="num">{{ getAmount(p, row.rowIndex) | currency:'MXN':'symbol-narrow':'1.0-0' }}</td>
								<td class="num pct">{{ getPercentage(p, row.rowIndex) | percent:'1.1-1' }}</td>
							</ng-container>
							<td class="num pct" *ngFor="let v of variations">
								{{ getVariation(v, row.rowIndex) | percent:'1.1-1' }}
							</td>
						</tr>

						<!-- Fila "Check" — ✅ Ok / ❌ Error por período -->
						<tr *ngIf="row.isCheck" class="check-row">
							<td class="concept" [style.padding-left.px]="12 + row.indent * 16">{{ row.label }}</td>
							<td class="check-cell" colspan="2"
								*ngFor="let p of periods"
								[ngClass]="getCheckStatus(p, row.rowIndex)">
								<ng-container *ngIf="getCheckStatus(p, row.rowIndex) as status">
									<i class="fa-solid"
										[class.fa-circle-check]="status === 'ok'"
										[class.fa-circle-xmark]="status === 'error'"></i>
									<span>{{ status === 'ok' ? 'Cuadra' : 'Error' }}</span>
								</ng-container>
							</td>
							<td *ngFor="let v of variations"></td>
						</tr>
					</ng-container>
				</tbody>
			</table>
		</div>
	</section>
</ng-container>

<ng-template #emptyState>
	<div class="empty-state">
		<i class="fa-solid fa-file-arrow-up"></i>
		<h3>Sin datos de EEFF Anual</h3>
		<p>Sube el Excel de Análisis de Riesgo arriba para ver los Estados Financieros.</p>
	</div>
</ng-template>
